import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireAuthenticatedUser } from '@/lib/route-guards';
import { useExtensionsStore } from '@/stores/extensions';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await requireAuthenticatedUser();

    // `/` lands on the Dashboard only while the `home-dashboard` extension is
    // enabled — the org-level switch that lets the feature ship dark. While it
    // is off (production today), the landing page stays what it always was:
    // People. The store memoises, so this awaits the network once per session.
    const store = useExtensionsStore.getState();
    if (!store.isLoaded) await store.load();
    const dashboardOn = useExtensionsStore.getState().isExtensionEnabled('home-dashboard');

    throw redirect({ to: dashboardOn ? '/dashboard' : '/people' });
  },
});
